import { Skeleton } from '@/components/ui/skeleton';

import CardBase from './CardBase';

interface CardSkeletonProps {
  title: string;
  titleVariant?: 'primary' | 'secondary';
  rows?: number;
}

/**
 * Skeleton loading state for integration configuration cards.
 * Renders placeholder rows that mimic form fields (label + input).
 */
const CardSkeleton = ({ title, titleVariant, rows = 3 }: CardSkeletonProps) => (
  <CardBase title={title} titleVariant={titleVariant}>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-10 w-full" />
      </div>
    ))}
  </CardBase>
);

export default CardSkeleton;
